import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, PhoneCall } from "lucide-react";
import { api } from "../api";

// Função robusta para aceitar data simples ou data/hora, ajustando fuso Brasil
function formatarDataSimples(dataStr) {
  if (!dataStr) return "--/--/----";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dataStr)) {
    dataStr = `${dataStr}T00:00:00-03:00`;
  }
  const data = new Date(dataStr);
  if (isNaN(data)) return "--/--/----";
  return data.toLocaleDateString("pt-BR");
}

// Formata hora para HH:mm
function formatarHora(hora) {
  if (!hora) return "--:--";
  return String(hora).slice(0, 5);
}

// Para criado_em (data/hora com fuso Brasil)
function formatarDataHoraFuso(dataStr) {
  if (!dataStr) return "--/--/----";
  try {
    const data = new Date(
      new Date(dataStr).toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo",
      }),
    );
    if (isNaN(data)) return "--/--/----";
    return data.toLocaleDateString("pt-BR");
  } catch {
    return "--/--/----";
  }
}

// Multi-loja-safe: busca empresa ativa primeiro
function getEmpresaId() {
  const empresaAtiva = JSON.parse(localStorage.getItem("empresaAtiva") || "{}");
  const usuarioLogado = JSON.parse(
    localStorage.getItem("usuarioLogado") || "{}",
  );
  return String(empresaAtiva?.id || usuarioLogado?.empresa_id || "").trim();
}

export default function LogsModalLead({ lead, onClose, usuarios = [] }) {
  const [listaInteracoes, setListaInteracoes] = useState([]);
  const [carregandoInteracoes, setCarregandoInteracoes] = useState(false);
  const [tarefasDaLead, setTarefasDaLead] = useState([]);
  const [carregandoTarefas, setCarregandoTarefas] = useState(false);
  const [transferencias, setTransferencias] = useState([]);
  const [carregandoTransferencias, setCarregandoTransferencias] =
    useState(false);

  const buscarInteracoes = async () => {
    setCarregandoInteracoes(true);
    try {
      const empresaId = getEmpresaId();

      console.log("🔎 [LogsModal] buscarInteracoes", {
        leadId: lead?.id,
        empresaId,
      });

      if (!empresaId || !lead?.id) {
        setListaInteracoes([]);
        return;
      }

      const params = { empresa_id: empresaId, id_lead: lead.id };
      const res = await api.get("/interacoes", { params });

      console.log("✅ [LogsModal] interações RAW response:", res);
      console.log("✅ [LogsModal] interações RAW data:", res?.data);

      const interacoes = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];

      setListaInteracoes(interacoes);
    } catch (e) {
      console.error(
        "❌ [LogsModal] erro ao buscar interações:",
        e?.response?.data || e,
      );
      setListaInteracoes([]);
    } finally {
      setCarregandoInteracoes(false);
    }
  };

  const buscarTarefas = async () => {
    setCarregandoTarefas(true);
    try {
      const empresaId = getEmpresaId();

      console.log("🔎 [LogsModal] buscarTarefas", {
        leadId: lead?.id,
        empresaId,
      });

      if (!empresaId || !lead?.id) {
        setTarefasDaLead([]);
        return;
      }

      const params = { empresa_id: empresaId, lead_id: lead.id };
      const res = await api.get("/tarefas", { params });

      console.log("✅ [LogsModal] tarefas RAW response:", res);
      console.log("✅ [LogsModal] tarefas RAW data:", res?.data);

      const tarefas = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];

      setTarefasDaLead(tarefas);
    } catch (e) {
      console.error(
        "❌ [LogsModal] erro ao buscar tarefas:",
        e?.response?.data || e,
      );
      setTarefasDaLead([]);
    } finally {
      setCarregandoTarefas(false);
    }
  };

  const buscarTransferencias = async () => {
    setCarregandoTransferencias(true);
    try {
      const empresaId = getEmpresaId();

      console.log("🔎 [LogsModal] buscarTransferencias", {
        leadRecebida: lead,
        leadId: lead?.id,
        empresaId,
      });

      if (!empresaId || !lead?.id) {
        console.warn(
          "⚠️ [LogsModal] lead.id ou empresaId ausente para transferências",
        );
        setTransferencias([]);
        return;
      }

      const res = await api.get(`/leads/${lead.id}/transferencias`, {
        params: { empresa_id: empresaId },
      });

      console.log("✅ [LogsModal] transferências RAW response:", res);
      console.log("✅ [LogsModal] transferências RAW data:", res?.data);

      const historico = Array.isArray(res?.data?.historico)
        ? res.data.historico
        : Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.historico)
            ? res.historico
            : Array.isArray(res)
              ? res
              : [];

      console.log("✅ [LogsModal] transferências historico final:", historico);

      setTransferencias(historico);
    } catch (e) {
      console.error(
        "❌ [LogsModal] erro ao buscar transferências:",
        e?.response?.data || e,
      );
      setTransferencias([]);
    } finally {
      setCarregandoTransferencias(false);
    }
  };

  useEffect(() => {
    if (lead?.id) {
      console.log("🧩 [LogsModal] lead recebida no modal:", lead);
      console.log("🧩 [LogsModal] lead.id:", lead.id);
      console.log(
        "🧩 [LogsModal] empresaAtiva LS:",
        localStorage.getItem("empresaAtiva"),
      );
      console.log(
        "🧩 [LogsModal] usuarioLogado LS:",
        localStorage.getItem("usuarioLogado"),
      );
      console.log("🧩 [LogsModal] empresaId final:", getEmpresaId());

      buscarInteracoes();
      buscarTarefas();
      buscarTransferencias();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lead]);

  const interacoesOrdenadas = (
    Array.isArray(listaInteracoes) ? listaInteracoes : []
  )
    .slice()
    .sort((a, b) => new Date(a.criado_em) - new Date(b.criado_em));

  const tarefasOrdenadas = (Array.isArray(tarefasDaLead) ? tarefasDaLead : [])
    .slice()
    .sort((a, b) => new Date(a.criado_em) - new Date(b.criado_em));

  const transferenciasOrdenadas = (
    Array.isArray(transferencias) ? transferencias : []
  )
    .slice()
    .sort((a, b) => new Date(a.criado_em) - new Date(b.criado_em));

  function getNomeOperador(id) {
    return (
      usuarios.find((u) => String(u.id) === String(id))?.nome || "Não informado"
    );
  }

  function getNomeCaptador(id) {
    return (
      usuarios.find((u) => String(u.id) === String(id))?.nome || "Não informado"
    );
  }

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="bg-white p-6 rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto relative"
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.95 }}
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-2xl font-bold text-blue-800 mb-1">
            📋 {lead?.nome_lead || "Lead sem nome"}
          </h2>

          <p className="text-xs text-gray-500 mb-2">
            Criada em: {formatarDataHoraFuso(lead?.criado_em)}
            <br />
            Operador: {getNomeOperador(lead?.id_usuario)}
            <br />
            <span className="font-bold text-blue-800 bg-blue-100 px-1 rounded">
              Captador: {getNomeCaptador(lead?.usuario_criador_id)}
            </span>
          </p>

          <p className="text-sm text-gray-500 mb-4">
            Histórico completo da lead
          </p>

          {/* --- TAREFAS --- */}
          <h3 className="text-lg font-semibold text-blue-800 mb-2">
            📝 Tarefas
          </h3>
          {carregandoTarefas ? (
            <p className="text-center text-slate-400">Carregando tarefas...</p>
          ) : tarefasOrdenadas.length === 0 ? (
            <p className="text-sm text-slate-500">Nenhuma tarefa registrada.</p>
          ) : (
            <ul className="space-y-3 mb-6">
              {tarefasOrdenadas.map((t, i) => {
                const resp = usuarios.find(
                  (u) => String(u.id) === String(t.responsavel_id),
                );

                return (
                  <li
                    key={t.id}
                    className="bg-slate-50 border rounded-md p-3 shadow-sm"
                  >
                    <p className="text-sm font-medium">
                      <span className="text-blue-600">#{i + 1}</span> —{" "}
                      {t.descricao || "Sem descrição"}
                    </p>

                    <div className="text-xs text-slate-600 mt-1 space-y-1">
                      <p>
                        🕒 Criada em: {formatarDataSimples(t.criado_em)} •
                        Vencimento: {formatarDataSimples(t.data_vencimento)}
                      </p>
                      <p>
                        👤 Responsável: {resp?.nome || "N/A"} • 🏷️ Status:{" "}
                        {t.status} • 🔥 Prioridade: {t.prioridade}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}

          {/* --- INTERAÇÕES --- */}
          <h3 className="text-lg font-semibold text-blue-800 mb-2">
            📞 Interações
          </h3>
          <div className="space-y-3 max-h-[300px] overflow-y-auto pr-1">
            {carregandoInteracoes ? (
              <div className="text-center text-slate-400">
                Carregando interações...
              </div>
            ) : interacoesOrdenadas.length === 0 ? (
              <div className="text-center text-slate-400">
                Sem interações cadastradas.
              </div>
            ) : (
              interacoesOrdenadas.map((item, idx) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="flex gap-3 bg-slate-50 rounded-lg p-3 border border-slate-200 shadow"
                >
                  <div className="pt-1">
                    {item.tipo?.toLowerCase() === "whatsapp" ? (
                      <MessageCircle className="w-5 h-5 text-green-600" />
                    ) : item.tipo?.toLowerCase() === "ligacao" ? (
                      <PhoneCall className="w-5 h-5 text-blue-600" />
                    ) : (
                      <div className="w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-xs font-bold">
                        {(item.tipo?.[0] || "O").toUpperCase()}
                      </div>
                    )}
                  </div>

                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="inline-block text-xs px-2 py-0.5 rounded bg-slate-200 text-slate-700 uppercase tracking-wide">
                        #{idx + 1} — {item.tipo || "Outro"}
                      </span>
                    </div>

                    <p className="text-sm text-slate-800">{item.descricao}</p>

                    <p className="text-xs text-slate-500 mt-1">
                      Criada em: {formatarDataHoraFuso(item.criado_em)}
                      {" • "}
                      Dia da Ação {formatarDataSimples(item.data)}
                      {" • "}
                      {item.hora ? formatarHora(item.hora) : "--:--"}
                    </p>
                  </div>
                </motion.div>
              ))
            )}
          </div>

          {/* --- TRANSFERÊNCIAS --- */}
          <h3 className="text-lg font-semibold text-blue-800 mb-2 mt-6">
            🔄 Transferências
          </h3>

          {carregandoTransferencias ? (
            <p className="text-center text-slate-400">
              Carregando transferências...
            </p>
          ) : transferenciasOrdenadas.length === 0 ? (
            <p className="text-sm text-slate-500">
              Nenhuma transferência registrada.
            </p>
          ) : (
            <ul className="space-y-3 mb-6">
              {transferenciasOrdenadas.map((t, i) => (
                <li
                  key={t.id}
                  className="bg-indigo-50 border border-indigo-200 rounded-md p-3 shadow-sm"
                >
                  <p className="text-sm font-medium text-indigo-800">
                    <span className="text-indigo-600">#{i + 1}</span> — Lead
                    transferida
                  </p>

                  <div className="text-xs text-slate-700 mt-1 space-y-1">
                    <p>
                      <strong>De:</strong> {t.nome_origem || "Não informado"}{" "}
                      <strong>→ Para:</strong>{" "}
                      {t.nome_destino || "Não informado"}
                    </p>
                    <p>
                      <strong>Motivo:</strong> {t.motivo || "Não informado"}
                    </p>
                    <p>
                      <strong>Observação:</strong>{" "}
                      {t.observacao || "Não informado"}
                    </p>
                    <p>
                      <strong>Transferido por:</strong>{" "}
                      {t.nome_transferido_por || "Não informado"}
                    </p>
                    <p>
                      <strong>Data:</strong> {formatarDataHoraFuso(t.criado_em)}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          )}

          <div className="mt-8 text-right">
            <button
              onClick={onClose}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
              type="button"
            >
              Fechar
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
